<template>
  <div class="relative min-h-screen overflow-hidden bg-midnight-900 text-steel-100">
    <div class="pointer-events-none absolute inset-0">
      <div class="absolute -left-24 top-12 h-72 w-72 rounded-full bg-neon-500/10 blur-3xl"></div>
      <div class="absolute right-0 top-1/3 h-80 w-80 rounded-full bg-white/5 blur-3xl"></div>
      <div class="absolute bottom-0 left-1/3 h-96 w-96 rounded-full bg-neon-400/10 blur-3xl"></div>
    </div>

    <div class="relative mx-auto flex min-h-screen max-w-6xl items-center px-6 py-14">
      <div class="grid w-full gap-10 lg:grid-cols-[1.1fr_0.9fr]">
        <section class="flex flex-col justify-center gap-8 text-center lg:text-left">
          <div class="inline-flex items-center gap-3 self-center lg:self-start">
            <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/10 ring-1 ring-white/15">
              <span class="text-lg font-semibold tracking-tight">D</span>
            </div>
            <div>
              <p class="font-display text-sm uppercase tracking-[0.35em] text-steel-400">DRVN</p>
              <p class="text-xs text-steel-200/80">{{ $t('authShell.tagline') }}</p>
            </div>
          </div>

          <div class="space-y-4">
            <h1 class="font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl">
              {{ title }}
            </h1>
            <p class="mx-auto max-w-xl text-base text-steel-200/90 sm:text-lg lg:mx-0">
              {{ subtitle }}
            </p>
          </div>

          <div class="flex flex-wrap justify-center gap-4 text-xs uppercase tracking-[0.3em] text-steel-400 lg:justify-start">
            <span class="rounded-full border border-white/10 px-4 py-2">{{ $t('authShell.chipGarage') }}</span>
            <span class="rounded-full border border-white/10 px-4 py-2">{{ $t('authShell.chipMembers') }}</span>
            <span class="rounded-full border border-white/10 px-4 py-2">{{ $t('authShell.chipCulture') }}</span>
          </div>
        </section>

        <section class="rounded-3xl border border-white/10 bg-midnight-800/60 p-8 shadow-glow backdrop-blur sm:p-10">
          <slot />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuthShell',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
}
</script>
